import { CButton, CImg, CLabel, CModal, CModalBody, CModalFooter } from '@coreui/react';
import * as React from 'react';
import { IImageProvider } from '../../abstraction';
import { AppLabels } from '../../core/AppLabels';
import { Utils } from '../../core/utils';

interface IProps {
	ShowMoreIcon: string;
	ShowMoreOnLoad: boolean;

	// Si ShowMoreIcon est vide, on affiche une image � partr des donn�es issues de Content & ContentType
	Content: string;
	ContentType: string;		// MIME type

	InlineStyle: string;
	bsSize: string;
	Visible: boolean;
	Class: string;
	Description: string;
	Key: string;
	ShowHeader: boolean;

	imgProvider: IImageProvider;
	children?: React.ReactNode;
}

interface IState {
	isOpen: boolean;
}

export class KControlImage extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);
		this.state = {
			isOpen: false,
		}
	}

	//#region Local events

	componentDidMount = () => {
		if (this.props.Content) {
			this.setState({
				isOpen: this.props.ShowMoreOnLoad
			})
		}
	}

	toggle = () => {
		this.setState({ isOpen: !this.state.isOpen });
	}

	//#endregion 

	//#region Rendus 

	renderImage = () => {
		if (this.props.Content) {
			if (this.props.ShowMoreIcon)
				return <div key={this.props.Key}><CImg className="icon" onClick={this.toggle} src={this.props.imgProvider.getImg(this.props.ShowMoreIcon)} /></div>
			return <div key={this.props.Key}> <CImg onClick={this.toggle} src={`data:${this.props.ContentType};base64,${this.props.Content}`} /> </div>
		}
		return "";
	}

	render() {
		if (!this.props.Visible) return null;

		let inlineStyle = Utils.decodeInlineStyleFromJson(this.props.InlineStyle);

		let img = this.renderImage();
		let header = this.props.ShowHeader == false ? "" : <CLabel htmlFor={this.props.Key} >{this.props.Description}</CLabel>

		return (
			<div className={`KControl KControlImage ${this.props.Class} ${this.props.bsSize}`} style={inlineStyle} >
				{header}
				{img}
				<CModal centered closeOnBackdrop={false} className={"KContentFullscreen "} show={this.state.isOpen} onClose={() => this.toggle()} >
					<CModalBody >
						<CImg onClick={this.toggle} src={`data:${this.props.ContentType};base64,${this.props.Content}`} />
					</CModalBody>
					<CModalFooter>
						<CButton color="primary" onClick={this.toggle}>{AppLabels.close}</CButton>{' '}
					</CModalFooter>
				</CModal>
			</div>
		)
	}

	//#endregion 
}